import './style.css';
import 'flowbite/dist/flowbite.js';
import './sidebar.js';
import './charts.js';
import './dark-mode.js';

// Have the courage to follow your heart and intuition.
